module.exports = {
  getActivityFeed: function (userId, feedType, limit) {
    return this.client.get(`/v${this.v}/activity_story/`, {
      params: {
        feed_id: userId,
        feed_type: feedType,
        limit: limit,
      },
    })
  },

  likeStory: function (userId, storyId, actorName) {
    return this.client.post('/vxproxy/api/0.1/activity_story/', {
      'object': {
        'type': 'like',
      },
      'verb': 'like',
      'target': {
        'id': storyId,
      },
      'actor': {
        'id': userId,
        'title': actorName,
      },
    })
  },

  unlikeStory: function (id) {
    return this.client.delete(`/vxproxy/api/0.1/activity_story/${id}`)
  },

  postStoryComment: function (text, actor, storyId) {
    return this.client.post('/vxproxy/api/0.1/activity_story/', {
      'target': {
        'id': storyId,
      },
      'verb': 'comment',
      'actor': {
        'gender': actor.gender,
        'type': 'user',
        'id': actor.id,
        'title': actor.title,
      },
      'object': {
        'text': text,
        'type': 'comment',
      },
    })
  },

  deleteComment: function (id) {
    return this.client.delete(`/vxproxy/api/0.1/activity_story/${id}`)
  },

  deleteStory: function (id) {
    return this.client.delete(`/vxproxy/v7.0/activity_story/${id}`)
  },

  getStoryComments: function (id) {
    return this.client.get(`/v${this.v}/activity_story/`, {
      params: {
        reply_type: 'comment',
        parent_story_id: id,
      },
    })
  },
}



// WEBPACK FOOTER //
// ./shared/mapmy/feed.js